// TotalByClient.jsx
import React from 'react';
import {
  ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Bar,
} from 'recharts';
import CustomTooltip from './CustomTooltip';
import '../plots/plots.css';
import { colorForKey } from './colors';

export function TtcByClientChart({ data }) {
  if (!data) return null;
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={data.rowsForChart} margin={{ top: 8, right: 16, left: 8, bottom: 0 }}>
      <CartesianGrid stroke="var(--plot-grid)" vertical={false} />
        <XAxis dataKey="label" tickMargin={8} />
        <YAxis tickMargin={8} tickFormatter={(value) => value.toLocaleString()} />
        <Tooltip content={<CustomTooltip />} />
        <Legend verticalAlign="bottom" height={28} />
        {data.seriesKeys.map((key, index) => (
          <Bar key={key} dataKey={key} fill={colorForKey(key, index)} barSize={8} radius={[2,2,0,0]} />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
}

export function TtcByClientTable({ data }) {
  if (!data) return null;

  // Helper for thousand formatting
  const formatNumber = (num) =>
    num !== null && num !== undefined ? num.toLocaleString('en-US') : '';

  return (
    <table className="anl-ttc-table anl-table">
      <thead>
        <tr>
          <th className="col-species">Species</th>
          {data.months.map((m) => <th key={m.label}>{m.label}</th>)}
          <th>Total (per Species)</th>
        </tr>
      </thead>
      <tbody>
        {data.seriesKeys.map((sp) => (
          <tr key={sp}>
            <td className="col-species">{sp}</td>
            {data.rowsForChart.map((row) => (
              <td key={row.label} className="col-number">
                {formatNumber(row[sp])}
              </td>
            ))}
            <td className="col-number">
              {formatNumber(data.totalsBySpecies[sp])}
            </td>
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr className="anl-total-row">
          <td>Total (Monthly)</td>
          {data.totalsByMonth.map((m) => (
            <td key={m.month} className="col-number">
              {formatNumber(m.total)}
            </td>
          ))}
          <td className="col-number">
            {formatNumber(data.totalsByMonth.reduce((s, x) => s + x.total, 0))}
          </td>
        </tr>
      </tfoot>
    </table>
  );
}